import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyGeraniumIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./GeraniumIcon-b96ac82c.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyGeraniumIcon as P };
